import { request, renderFormData } from '@/utils/request'
import { API_JAVA } from '@/utils/base'

const path = API_JAVA
/*
  产品树型
*/
export async function apiGetProductListTree(params) {
  return request(path + '/basedata/product/listTree', {
    method: 'GET',
    data: params
  })
}


/*
  产品分页查询
*/
export async function apiGetProductList(params) {
  return request(path + '/basedata/product/listPage', {
    method: 'POST',
    body: params
  })
}

/**
 * 保存产品
 */
export async function apiSaveProduct(params) {
  return request(path + '/basedata/product/save', {
    method: 'POST',
    body: params
  })
}


/**
 * 删除产品
 */
export async function apiDeleteProduct(params) {
  return request(path + '/basedata/product/delete', {
    method: 'POST',
    body: renderFormData(params)
  })
}
/*
  材质分页查询
*/
export async function apiGetMaterialList(params) {
  return request(path + '/basedata/material/listPage', {
    method: 'POST',
    body: params
  })
}

/**
   * 保存材质
   */
export async function apiSaveMaterial(params) {
  return request(path + '/basedata/material/save', {
    method: 'POST',
    body: params
  })
}
/**
   * 删除材质
   */
export async function apiDeleteMaterial(params) {
  return request(path + '/basedata/material/delete', {
    method: 'POST',
    body: renderFormData(params)
  })
}
/*
  规格分页查询
*/
export async function apiGetSpecialList(params) {
  return request(path + '/basedata/special/listPage', {
    method: 'POST',
    body: params
  })
}

/**
   * 保存规格
   */
export async function apiSaveSpecial(params) {
  return request(path + '/basedata/special/save', {
    method: 'POST',
    body: params
  })
}
/**
   * 删除规格
   */
export async function apiDeleteSpecial(params) {
  return request(path + '/basedata/special/delete', {
    method: 'POST',
    body: renderFormData(params)
  })
}
/*
  生产厂家分页查询
*/
export async function apiGetFactoryPage(params) {
  return request(path + '/basedata/factory/listPage', {
    method: 'POST',
    body: params
  })
}
/*
  生产厂家查询
*/
export async function apiGetFactoryList() {
  return request(path + '/basedata/factory/list', {
    method: 'POST'
  })
}

/**
 * 保存生产厂家
 */
export async function apiSaveFactory(params) {
  return request(path + '/basedata/factory/save', {
    method: 'POST',
    body: params
  })
}
/**
 * 删除生产厂家
 */
export async function apiDeleteFactory(params) {
  return request(path + '/basedata/factory/delete', {
    method: 'POST',
    body: renderFormData(params)
  })
}

/*
  查询FId子选项
*/
export async function apiGetOptionList(params) {
  return request(path + '/basedata/option/list', {
    method: 'POST',
    body: renderFormData(params)
  })
}
/**
 * 保存选项
 */
export async function apiSaveOption(params) {
  return request(path + '/basedata/option/save', {
    method: 'POST',
    body: params
  })
}
/**
 * 删除选项
 */
export async function apiDeleteOption(params) {
  return request(path + '/basedata/option/delete', {
    method: 'POST',
    body: renderFormData(params)
  })
}
/*
  返回所有选项键值对
*/
export async function apiGetOptionListAllByMap(params) {
  return request(path + '/basedata/option/listAllByMap', {
    method: 'GET',
    data: params
  })
}
/*
  返回所有规格材质
*/
export async function apiGetlistSMOfProduct(params) {
  return request(`${path}/basedata/product/listSMOfProduct?type=${params.type}`, {
    method: 'GET',
  })
}
/*
  返回所有顶级选项键值对
*/
export async function apiGetOptionListAllSubByMap(params) {
  return request(path + '/basedata/option/listAllSubByMap', {
    method: 'GET',
    data: params
  })
}

/*
*/
export async function apiGetOptionListAllSubByMapNoCache(params) {
  return request(path + '/basedata/option/listAllSubByMapNoCache', {
    method: 'GET',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/services/static.js